import __var_0__ from '@stdlib/constants/math/float64-pinf';
import __var_1__ from '@stdlib/constants/math/float64-ninf';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var PINF = __var_0__;
var NINF = __var_1__;


// MAIN //

/**
* Returns the minimum value of the y-axis domain.
*
* @private
* @returns {number} minimum value of the y-axis domain
*/
function get() {
	/* eslint-disable no-invalid-this */
	var min;
	var len;
	var d;
	var i;

	if ( this._yMin === null ) {
		len = this._data.length;
		min = PINF;
		for ( i = 0; i < len; i++ ) {
			d = this._data[ i ];
			if ( this._isDefined( d ) && d !== NINF && d < min ) {
				min = d;
			}
		}
		return min;
	}
	return this._yMin;
}


// EXPORTS //
export default get;
